import React, { Component } from 'react'
import { Table, Tooltip, Avatar, Modal, Button, Badge, Form, Input, message } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import config from '../../utils/config'
import { batchObject } from '../../services/batch'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
var Icon = require('react-fontawesome');

const { Column } = Table;
const confirm = Modal.confirm
const ButtonGroup = Button.Group;
const FormItem = Form.Item;

class Manager extends Component {

	constructor (props) {
		super(props);

		this.state = {};

		if (localStorage.getItem('currentHotel')) 
			this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
	}

    loadMore () {
    	if (this.props.manager.skip < this.props.manager.total_items) {

    		let query = {type: 'gerente'};

    		this.props.dispatch({type: 'manager/query', payload: {
    			where: query,
				skip: this.props.manager.skip,
				limit: this.props.manager.limit,
				count: 1,
				order: '-createdAt'
	    	}});
    	}
    }

    delete_item (item) {

    	let dispatch = this.props.dispatch

    	confirm({
	    	title: '¿Estás seguro que deseas eliminar el gerente?',
	      	onOk () {
	        	dispatch({type: 'manager/removeItem', payload: item});
	      	}
	    })
    }

    showModalPassword (item) { this.setState({ showModalPassword: true, currentItem: item }); }

    savePassword (item) {

    	var new_password = this.props.form.getFieldValue('new_password');

    	if (!new_password) {
    		message.error('Ingrese el nuevo password');	

    	} else {
	    	batchObject('_User', item.objectId, 'PUT', {name: new_password}).then((resp) => {
	    		console.log(resp);
	    	});
    	}
    }

    render () {
	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
	            		Gerentes

	            		<div className="pull-right">
                            <Button type='primary'>
                                <Link to="/managers/new-manager"><Icon name="plus" /> Agregar nuevo usuario</Link>
                            </Button>
                        </div>
	            	</h1>
	            </section>

	            <section className="content">
	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.manager.managers} 
		                                    	rowKey="objectId" size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>
		                                    	
		                                    	<Column key="picture"
		                                            render={(item) => (
		                                                <span>
		                                                	{!item.picture ?
		                                                		<Avatar size="large" src="assets/img/avatar5.png" /> :
		                                                		<Avatar size="large" src={config.externalUrl + 'uploads/users/' + item.picture} />
		                                                	}
		                                                </span>
		                                            )}
		                                        />
		                                        <Column title="Nombre" dataIndex="name" key="name" />
		                                        <Column title="Username" dataIndex="username" key="username" />
		                                        <Column title="Email" dataIndex="email" key="email" />
		                                        <Column title="Teléfono" dataIndex="phone" key="phone" />
		                                        <Column title="Celular" dataIndex="mobile_phone" key="mobile_phone" />
		                                        <Column title="Hoteles" key="hotels" render={(item) => (
		                                        	item.hotels && item.hotels.map(d => <span key={d.objectId}>{d.name},<br /></span>)
		                                        )} />
		                                        <Column title="Fecha de registro" key="createdAt" render={(item) => (
		                                        	<span>{moment(item.createdAt).format('DD/MM/YYYY')}</span>
		                                        )}/>
		                                        <Column title="Status" key="active" render={(item) => (
		                                        	<span>
                                                        {item.active
                                                        	? <span><Badge status="success" /><small>Activo</small></span>
                                                            : <span><Badge status="warning" /><small>Suspendido</small></span>
                                                        }
                                                    </span>
		                                        )}/>
		                                        <Column title="Acciones" key="action"
		                                            render={(item) => (
		                                                <span className="actions">
		                                                	<ButtonGroup>
			                                                    <Tooltip placement="bottom" title="Editar">
			                                                    	<Button>
			                                                        	<Link to={`/managers/details/${item.objectId}`}><Icon name="edit" /></Link>
			                                                        </Button>
			                                                    </Tooltip>

			                                                    <Tooltip placement="bottom" title="Cambiar contraseña">
			                                                    	<Button>
			                                                        	<Link onClick={() => { this.showModalPassword(item) }}><Icon name="key" /></Link>
			                                                        </Button>
			                                                    </Tooltip>

			                                                    <Tooltip placement="bottom" title="Eliminar">
			                                                    	<Button>
			                                                        	<Link onClick={() => { this.delete_item(item) }}><Icon name="trash" /></Link>
			                                                        </Button>
			                                                    </Tooltip>
		                                                    </ButtonGroup>
		                                                </span>
		                                            )}
		                                        />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>

	            <Modal
                    visible={this.state.showModalPassword}
                    width={300}
                    title="Cambiar contraseña"
                    onCancel={() => { this.setState({ showModalPassword: false }); }}
                    footer={[
                        <Button key="back" onClick={() => { this.setState({ showModalPassword: false }); }}>Cancelar</Button>,
                        <Button key="details" type="primary" onClick={() => { this.savePassword(this.state.currentItem) }}>
                            <Icon name="check" /> Guardar
                        </Button>
                    ]} 
                >
                    {this.state.showModalPassword
                        ? <div className="row">
                            <div className="col-md-12">
                                <FormItem label="Nueva contraseña">
                                    {this.props.form.getFieldDecorator('new_password', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, ingrese la nueva contraseña'
                                        }]
                                    })(
                                        <Input type="password" size='large' />
                                    )}
                                </FormItem>
                            </div>
                        </div>
                        : ''
                    }
                </Modal>
	        </div>
	    )
	}
}

export default connect(({manager, app}) => ({manager, app}))(Form.create()(Manager))


// WEBPACK FOOTER //
// ./src/components/managers/index.js